import React, { useContext, useState } from 'react';
import SideNavigation, { SideNavigationProps } from "@amzn/awsui-components-react/polaris/side-navigation";
import TPENavigator from './TPENavigator';
import CONSTANTS from 'src/utils/constants';
import { useLocation } from 'react-router-dom';
import { GlobalAppContext } from './App';

// Allowlist for Report Analysis page — keep in sync with ReportAnalysis.tsx
const REPORT_ANALYSIS_ALLOWED_USERS = CONSTANTS.PAGE_NAV.REPORT_ANALYSIS.ALLOWED_USERS;
const IS_LOCAL = window.location.hostname === 'localhost';
const IS_REPORT_ANALYSIS_ENABLED = IS_LOCAL || CONSTANTS.ENVIRONMENT_VARIABLES.TPE_UI_STAGE === 'gamma';

export default () => {
  const { pathname } = useLocation();
  const { globalState } = useContext(GlobalAppContext);
  const { selectedTab } = globalState;
  const userAlias = localStorage.getItem('alias') || '';
  const userEmail = `${userAlias}@amazon.com`;

  const getActiveHref = () => {
    const pathParts = pathname.split('/');
    if (pathParts.length > 1) {
      return '/' + pathParts[1];
    }
    return '/';
  }

  const createSupportTicket = () => {
    if (pathname.startsWith(CONSTANTS.PAGE_NAV.REPORT_DASHBOARD.URL) 
        || (pathname.startsWith(CONSTANTS.PAGE_NAV.MONTH_END_CLOSE.URL) 
            && (selectedTab == CONSTANTS.MEC_TABS.PREVALIDATION || selectedTab == CONSTANTS.MEC_TABS.JE_STATUS_DASHBOARD))) {
        window.open(CONSTANTS.ENVIRONMENT_VARIABLES.REPORTING_SUPPORT_TICKET_TEMPLATE);
    } else {
        window.open(CONSTANTS.ENVIRONMENT_VARIABLES.SUPPORT_TICKET_TEMPLATE);
    }
  }

  const getAdditionalItems = () => {
    if (CONSTANTS.ENVIRONMENT_VARIABLES.TPE_UI_STAGE === 'prod') {
      return [
        { type: "divider" },
        { type: "link", text: "Report issue", href:"/support", external: true }
      ]
    }
    return [];
  }

  const [navigateURL, setNavigateURL] = useState('');

  const navItems: SideNavigationProps.Item[] = [
    { type: "link", text: "Home", href: CONSTANTS.PAGE_NAV.DASHBOARD.URL },
    { type: "link", text: "TP Worklists", href: CONSTANTS.PAGE_NAV.AGREEMENTS.URL },
    { type: "link", text: "Calculation Manager", href: CONSTANTS.PAGE_NAV.CALCULATIONS.URL },
    { type: "link", text: "Reports", href: CONSTANTS.PAGE_NAV.REPORT_DASHBOARD.URL },
    ...(IS_REPORT_ANALYSIS_ENABLED && REPORT_ANALYSIS_ALLOWED_USERS.includes(userEmail)
      ? [{ type: "link" as const, text: "Report Analysis", href: CONSTANTS.PAGE_NAV.REPORT_ANALYSIS.URL }]
      : []),
    { type: "link", text: "Month-End Close", href: CONSTANTS.PAGE_NAV.MONTH_END_CLOSE.URL },
    ...getAdditionalItems() as SideNavigationProps.Item[]
  ];

  return (
    <>
    <TPENavigator path={navigateURL} fromLeftNav={true} />
      <SideNavigation
        activeHref={getActiveHref()}
        header={{
          href: CONSTANTS.PAGE_NAV.DASHBOARD.URL,
          text: "Automated Transfer Pricing"
        }}
        onFollow={event => {
          event.preventDefault();
          if (!event.detail.external) {
            setNavigateURL(event.detail.href);
          } else {
            createSupportTicket();
          }
        }}
        items={navItems}
      />
    </>
  );
}
